export default {
    data() {
        return {
            resultCodesSuccess: ['000.000.000', '000.000.100', '000.100.110', '000.100.111', '000.100.112', '000.300.000', '000.300.100', '000.300.101', '000.300.102', '000.600.000'],
            resultCodesManuallyReview: ['000.400.000', '000.400.010', '000.400.020', '000.400.040', '000.400.050', '000.400.060', '000.400.070', '000.400.080', '000.400.090', '000.400.100'],
            resultCodesPending: ['000.200.000', '000.200.100', '000.200.101', '000.200.102', '000.200.200', '100.400.500', '800.400.500', '800.400.501', '800.400.502']
          }
    },
    methods: {
        sweetAlert(response) {
  
          // Result codes
          if(typeof response === 'object' && 'result' in response) {
            if(this.resultCodesSuccess.includes(response.result.code)) {
              this.$swal({
                type: 'success',
                title: 'Successful Transaction',
                html: '<b>Result code:</b> ' + response.result.code + '<br/> ' + response.result.description
              })
            }
            else if(this.resultCodesManuallyReview.includes(response.result.code)) {
              this.$swal({
                type: 'success',
                title: 'Successful Transaction - Manual Reviewing',
                html: '<b>Result code:</b> ' + response.result.code + '<br/>' + response.result.description
              })
            }
            else if(this.resultCodesPending.includes(response.result.code)) {
              this.$swal({
                type: 'warning',
                title: 'Pending Transaction',
                html: '<b>Result code:</b> ' + response.result.code + '<br/>' + response.result.description
              })
            }
            else if(!this.resultCodesSuccess.includes(response.result.code || !this.resultCodesManuallyReview.includes(response.result.code) || !this.resultCodesPending.includes(response.result.code))) {
              this.$swal({
                type: 'error',
                title: 'Rejected Transaction',
                html: '<b>Result code:</b> ' + response.result.code + '<br/>' + response.result.description
              })
            }
          }

          // OnBoarding
          else if(response === Object(response) && 'division' in response) {
            this.$swal({
              type: 'success',
              title: 'Success',
              html: 'Merchant has been successfully boarded.'
            })
          }
          else if(typeof response === 'string') {
            this.$swal({
              type: 'error',
              title: 'Failed',
              html: response
            })
          }

          // Kindred
          else if(response.data == 'kindred-csv-success') {
            this.$swal({
              type: 'success',
              title: 'Success',
              html: 'Kindred CSV file has been successfully uploaded.'
            })
          }
          else if(response.data == 'kindred-csv-fail') {
            this.$swal({
              type: 'error',
              title: 'Failed',
              html: 'Kindred CSV file upload failure.'
            })
          }

          // Invoices
          else if(response.data == 'invoices-csv-success') {
            this.$swal({
              type: 'success',
              title: 'Success',
              html: 'Invoices CSV file has been successfully uploaded and emails sent.'
            })
          }
          else if(response.data == 'invoices-csv-fail') {
            this.$swal({
              type: 'error',
              title: 'Failed',
              html: 'Invoices CSV file upload failure.'
            })
          }
        }
    }
}